export default __webpack_public_path__ + "static/media/flag-4.34ad4981.gif";